module.exports = __webpack_public_path__ + "img/planet-top-desktop.c96c50e.png";